import { currency, paddingPhoneNumber, vuexEventPathGenerator, } from '@/utils';
import { userPermission, userPermissionListSwapKeyValue, } from '@/constants';
import { userLevel, userLevelCode, userLevelKr, } from '@/constants/userLevel';
import { formatPhoneNumber } from '@/utils/regularExpression';
import { barogoHQLatLng } from '@/constants/global';
const getterType = {
    // System state
    isInitialized: 'isInitialized',
    useYn: 'useYn',
    // Hub info
    isHead: 'isHead',
    name: 'name',
    hubInfo: 'hubInfo',
    hubInfoForHubSelector: 'hubInfoForHubSelector',
    hubId: 'hubId',
    hubCode: 'hubCode',
    hubName: 'hubName',
    hubLatLng: 'hubLatLng',
    getterHubConfig: 'getterHubConfig',
    // Distributor info
    distributorId: 'distributorId',
    distributorName: 'distributorName',
    isDistUser: 'isDistUser',
    // User info
    userId: 'userId',
    userName: 'userName',
    phone: 'phone',
    userTelephone: 'userTelephone',
    maskingPhoneNumber: 'maskingPhoneNumber',
    // User level & permissions
    userLevel: 'userLevel',
    userLevelName: 'userLevelName',
    userLevelNameKr: 'userLevelNameKr',
    userLevelPlainName: 'userLevelPlainName',
    getterUserPermission: 'getterUserPermission',
    getterAllPermission: 'getterAllPermission',
    isPossibleGetHubList: 'isPossibleGetHubList',
    isPermissionOtherHub: 'isPermissionOtherHub',
    getterIsPermissionShareConfig: 'getterIsPermissionShareConfig',
    // Delivery charge
    addChargeApplyYn: 'addChargeApplyYn',
    addDeliveryCharge: 'addDeliveryCharge',
    addDeliveryChargeRate: 'addDeliveryChargeRate',
    // Worker
    workerBulletin: 'workerBulletin',
    // Baromoney
    baromoney: 'baromoney',
    baromoneyHistory: 'baromoneyHistory',
    withdrawableBaromoney: 'withdrawableBaromoney',
    depositBaromoney: 'depositBaromoney',
    storeMinusBaromoney: 'storeMinusBaromoney',
    hubWorkerBaromoney: 'hubWorkerBaromoney',
};
export const userGetterType = vuexEventPathGenerator(getterType, 'user');
const getter = {
    [getterType.isInitialized]: (state) => state.initUser,
    [getterType.hubInfo]: (state) => state.hubInfo,
    /**
     * 로그인한 허브의 허브셀렉터 정보 리턴
     * @param state
     * @returns
     */
    [getterType.hubInfoForHubSelector]: (state) => ({
        key: state.hubInfo?.code,
        text: state.hubInfo?.name,
        value: {
            type: 'HUB',
            id: state.hubInfo?.code,
            hubId: state.hubInfo?.code,
            hubName: state.hubInfo?.name,
        },
    }),
    /**
     * 허브 리스트를 조회할 수 있는지 여부
     */
    [getterType.isPossibleGetHubList]: (state, getters) => getters.isDistUser || getters.isPermissionOtherHub,
    [getterType.useYn]: (state) => state.userInfo?.useYn,
    /** 총판 여부 */
    [getterType.isHead]: (state) => state.hubInfo?.headYn === 'Y',
    /** 허브 혹은 총팡명 */
    [getterType.name]: (state, getters) => ((getters.isHead && state.hubInfo?.distributorDTO?.name)
        ? getters.distributorName : getters.hubName),
    [getterType.distributorId]: (state) => state.hubInfo?.distributorId,
    [getterType.distributorName]: (state) => state.hubInfo?.distributorDTO?.name,
    [getterType.hubId]: (state) => state.hubInfo?.code,
    [getterType.hubCode]: (state) => state.hubInfo?.code,
    [getterType.hubName]: (state) => state.hubInfo?.name,
    [getterType.addChargeApplyYn]: (state) => state.hubInfo?.addChargeApplyYn,
    [getterType.workerBulletin]: (state) => state.hubInfo?.workerBulletin,
    [getterType.addDeliveryCharge]: (state) => state.hubInfo?.addDeliveryCharge,
    [getterType.addDeliveryChargeRate]: (state) => state.hubInfo?.addDeliveryChargeRate,
    [getterType.baromoney]: (state) => currency(state.baromoney?.baromoney),
    [getterType.withdrawableBaromoney]: (state) => currency(state.baromoney?.withdrawableBaromoney),
    [getterType.depositBaromoney]: (state) => currency(state.baromoney?.depositBaromoney),
    [getterType.storeMinusBaromoney]: (state) => currency(state.baromoney?.storeMinusBaromoney),
    [getterType.hubWorkerBaromoney]: (state) => currency(state.baromoney?.hubWorkerBaromoney),
    [getterType.baromoneyHistory]: (state) => state.baromoney?.baromoneyHistory,
    [getterType.phone]: (state) => state.hubInfo?.phone,
    [getterType.maskingPhoneNumber]: (state, getters) => paddingPhoneNumber(formatPhoneNumber(getters.phone)),
    [getterType.userId]: (state) => state.userInfo?.userId,
    [getterType.userName]: (state) => state.userInfo?.name,
    [getterType.userTelephone]: (state) => state.userInfo?.telephone,
    [getterType.userLevelNameKr]: (state) => {
        if (!state.userInfo) {
            console.log('[userLevelName] 유저 정보가 없습니다');
            return '';
        }
        if (state.userInfo.level >= 40) {
            return userLevelKr.DISTRIBUTOR;
        }
        return userLevelKr.HUB;
    },
    [getterType.userLevelName]: (state) => {
        if (!state.userInfo) {
            console.log('[userLevelName] 유저 정보가 없습니다');
            return '';
        }
        if (state.userInfo.level >= 40) {
            return userLevel.DISTRIBUTOR;
        }
        return userLevel.HUB;
    },
    [getterType.userLevel]: (state) => {
        if (!state.userInfo) {
            console.log('[userLevelName] 유저 정보가 없습니다');
            return '';
        }
        return state.userInfo.level;
    },
    [getterType.userLevelPlainName]: (state) => {
        if (!state.userInfo) {
            console.log('[userLevelName] 유저 정보가 없습니다');
            return '';
        }
        return userLevelCode[state.userInfo.level].text;
    },
    // 타허브 선택 권한
    [getterType.isPermissionOtherHub]: (state) => state.userPermission.has(userPermission.P_GET_OTHER_HUB),
    // 공유정보 설정 권한 여부
    [getterType.getterIsPermissionShareConfig]: (state) => userPermission.P_GET_SHARE_MANAGEMENT()
        .every((code) => state.userPermission.has(code)),
    [getterType.isDistUser]: (state, getters) => getters.userLevelName === userLevel.DISTRIBUTOR,
    [getterType.hubLatLng]: (state) => {
        // 허브 정보 없을 경우 대응 >> 본사 위치로 대신 사용
        if (!state.hubInfo) {
            return [
                barogoHQLatLng[0],
                barogoHQLatLng[1],
            ];
        }
        return [
            state.hubInfo.latitude,
            state.hubInfo.longitude,
        ];
    },
    // 권한 여부 판단
    [getterType.getterUserPermission]: (state) => (permission = [], isEvery = false) => {
        const testType = isEvery ? 'every' : 'some';
        if (!Array.isArray(permission)) {
            throw new Error('[getterUserPermission] permission is Not Array.');
        }
        if (permission[testType]((p) => (state.userPermission.has(p)))) {
            return true;
        }
        return false;
    },
    // 유저의 모든 권한 조회
    [getterType.getterAllPermission]: (state) => {
        const result = {};
        state.userPermission.forEach((permissionNumber) => {
            const key = userPermissionListSwapKeyValue[permissionNumber];
            // 권한 없을시 아래 링크에서 확인 후 추가해 주세요.
            // https://www.notion.so/barogohq/7828d33d527647faad316ffa62c6d920?v=e2c5f2d7dd0d48049d13ee1d4ccc60c8
            if (!key) {
                // log 너무 많아져서 임시 주석
                // console.log('[getterAllPermission] Permission not found: ', permissionNumber);
                return;
            }
            result[key] = permissionNumber;
        });
        return result;
    },
    /** 허브 설정 */
    [getterType.getterHubConfig]: (state) => state.hubInfo.hubConfigurationDTO,
};
export default getter;
